var $ = require('jquery');

$(function () {

    var isPageEditor = window.SitecoreUtilities.isPageEditor;

    if (!isPageEditor()) {
        var scrollTimer, lastScrollFireTime = 0;
        var prevScrollpos = window.pageYOffset;
        $(window).scroll(function () {

            if ($('.content-access__overlay').hasClass('open')) {
                return;
            }

            if ($('body').hasClass('show-location-menu')) {
                return;
            }

            if ($('body').hasClass('show-header-menu')) {
                return;
            }

            var minScrollTime = 100;
            var now = new Date().getTime();


            function processScroll() {
                if (document.getElementById('header') && document.getElementById('header').scrollHeight) {
                    var headerHeight = document.getElementById('header').scrollHeight;
                    var currentScrollPos = window.pageYOffset;

                    if (document.getElementById('header').scrollHeight < prevScrollpos) {
                        //scroll up vs down
                        if (prevScrollpos >= currentScrollPos) {
                            document.getElementById('header').style.top = '0px';
                        } else {
                            // if the language dropdown is open do not reset the top to a negative number
                            if (!$('.header__utility-menu div.dropdown-filter.open').length) {
                                document.getElementById('header').style.top = (headerHeight * -1) + 'px';
                            }
                        }
                    } else {
                        document.getElementById('header').style.top = '0px';
                    }
                    prevScrollpos = currentScrollPos;
                }
            }

            if (navigator.userAgent.match(/Trident\/7\./)) { // if IE
                //ie11 keeps firing multiple scroll events that cause inconsistency in scroll height. Have to throttle the events
                if (!scrollTimer) {
                    if (now - lastScrollFireTime > (3 * minScrollTime)) {
                        processScroll(); // fire immediately on first scroll
                        lastScrollFireTime = now;
                    }
                    scrollTimer = setTimeout(function () {
                        scrollTimer = null;
                        lastScrollFireTime = new Date().getTime();
                        processScroll();
                    },
                        minScrollTime);
                }
            } else {
                processScroll();
            }
        });
    }
});

// set this function to be globally accessible
// navElement - the element that will have class applied to it for inner scrolling
// elementToCheck - the element to compare window height against; if 'desktopMenu' use hard coded 300
// scrollClass - class to add to navElement if scrollbars are needed
window.setScrollableNav = function (navElement, elementToCheck, scrollClass) {
    // height of the browser window
    // Global Menu dynamic scroll Starts
    var viewHeight = window.innerHeight;

    var cookieHeight = (document.querySelector(".cc-banner")) ? document.querySelector(".cc-banner").clientHeight : ((document.querySelector(".optanon-alert-box-wrapper")) ? document.querySelector(".optanon-alert-box-wrapper").clientHeight : ((document.querySelector("#onetrust-banner-sdk")) ? document.querySelector("#onetrust-banner-sdk").clientHeight : 0));

    if ((!$(".cc-banner").hasClass("cc-invisible") && $(".cc-banner")) || $('#onetrust-banner-sdk')) {
        viewHeight = viewHeight - cookieHeight;
    }

    if (document.querySelector(".locations__countries-wrapper .resp-tab-content-active") && ((document.querySelector(".locations__countries-wrapper .resp-tab-content-active").clientHeight + 200) < viewHeight)) {
        $(".header__utility-menu .locations").css({ height: "auto" });
    } else {
        $(".header__utility-menu .locations").css({ height: (window.innerWidth <= 768 ? "96vh" : "75vh"), overflow: "auto" });
    }
    // Global Menu dynamic scroll Ends

    // height of the locations html element.  this is dependent on the setTimeout to allow the element time to build after css update to be visible
    var navHeight = 0;
    if (elementToCheck === 'header__sub-menu') {
        navElement.removeClass('scrollable_nav');
        navHeight = navElement.innerHeight() + 100;
    } else {
        navHeight = document.getElementsByClassName(elementToCheck)[0].scrollHeight;
    }

    // if viewHeight is less than or equal in height to the navHeight add scrollbars
    if (viewHeight <= navHeight) {
        // set navElement to be scrollable and have a height equal to the window height
        $(navElement).addClass(scrollClass);

        // set the navElement's wrapper div to add padding for IE to not cut off the bottom on mobile
        if (elementToCheck === 'header__sub-menu' && $('.content-access__overlay').hasClass('open')) {
            $('html').css('overflow-y', 'hidden');
            $('.header__main-menu').addClass('scroll-hidden');
            $('.header__utility-menu').addClass('scroll-hidden');
        }
    } else {
        // reset elements by removing classes
        $(navElement).removeClass(scrollClass);

        if (elementToCheck === 'header__sub-menu') {
            $('html').removeAttr('style');
        }
    }
}